import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { ClustersPath, clustersPagePath } from 'pages/clusters/routes';
import { MarkingPath, markingPagePath } from 'pages/marking/routes';
import { AuthorisableRoute } from 'policies/route.policy';

export type MainMenuItem = {
  label: string;
  to: string;
  icon: IconProp;
  isActive: (path: string) => boolean;

  // The route associated with permissions for showing/hiding the menu item. Only needed for
  // restricted menu items; if not specified then the route will be considered unrestricted and
  // always visible when logged in.
  authorisableRoute?: AuthorisableRoute;
};

export const MAIN_MENU_ITEMS: MainMenuItem[] = [
  {
    label: 'Dashboard',
    icon: 'home',
    to: '/',
    isActive: (path) => path === '/' || path.startsWith('/product'),
    authorisableRoute: AuthorisableRoute.Dashboard
  },
  {
    label: 'Reports',
    icon: 'chart-bar',
    to: '/reports/aggregated',
    isActive: (path) => path.startsWith('/reports'),
    authorisableRoute: AuthorisableRoute.ReportsWildcard
  },
  {
    label: 'Marking',
    icon: 'pen-to-square',
    to: MarkingPath.MarkerDashboard,
    isActive: (path) => path.startsWith(markingPagePath),
    authorisableRoute: AuthorisableRoute.MarkingWildcard
  },
  {
    label: 'Clusters',
    icon: 'circle-nodes',
    to: ClustersPath.ClusterInfo,
    isActive: (path) => path.startsWith(clustersPagePath),
    authorisableRoute: AuthorisableRoute.ClustersWildcard
  },
  {
    label: 'Admin',
    icon: 'user-secret',
    to: '/admin',
    isActive: (path) => path.startsWith('/admin'),
    authorisableRoute: AuthorisableRoute.AdminWildcard
  },
  {
    label: 'Classes',
    icon: 'users',
    to: '/classes',
    isActive: (path) => path.startsWith('/classes'),
    authorisableRoute: AuthorisableRoute.ClassesWildcard
  },
  {
    label: 'Users',
    icon: 'address-card',
    to: '/organisation-users',
    isActive: (path) => path.startsWith('/organisation-users'),
    authorisableRoute: AuthorisableRoute.UsersWildcard
  },
  {
    label: 'Subscriptions',
    icon: 'cart-shopping',
    to: '/subscriptions',
    isActive: (path) => path.startsWith('/subscriptions'),
    authorisableRoute: AuthorisableRoute.SubscriptionsWildcard
  },
  {
    label: 'Organisations',
    to: '/organisations',
    icon: 'sitemap',
    isActive: (path) => path.startsWith('/organisations')
    // Not authorised / always visible when logged in.
  }
];
